<script>
export default {
  name: 'has-filters',
  data () {
    return {
      desktopViewport: null,
      mobileViewport: null
    }
  },
  mounted () {
    this.desktopViewport = window.matchMedia('(min-width: 860px)');
    this.mobileViewport = window.matchMedia('(max-width: 859px)');

    if (this.desktopViewport.matches) {
      this.filtersBtnVisible = false;
      this.filtersOpen = true;
    }

    if (this.mobileViewport.matches) {
      this.filtersBtnVisible = true;
      this.filtersOpen = false;
    }

    this.desktopViewport.addListener(this.setDesktopFilters);
    this.mobileViewport.addListener(this.setMobileFilters);
  },
  methods: {
    setDesktopFilters (mq) {
      if (mq.matches) {
        this.filtersBtnVisible = false;
        this.filtersOpen = true;
      }
    },
    setMobileFilters (mq) {
      if (mq.matches) {
        this.filtersBtnVisible = true;
        this.filtersOpen = false;
      }
    }
  },
  beforeDestroy () {
    this.desktopViewport.removeListener(this.setDesktopFilters);
    this.mobileViewport.removeListener(this.setMobileFilters);
  }
}
</script>
